import React, { useEffect, useState } from 'react';

const YouTubeEvents = ({ channelNames }) => {
    const [events, setEvents] = useState([]);
    const apiKey = 'AIzaSyAgzbkGahzTEmHMOTh9YCsolasPCECDdv0'; // Замените на ваш API ключ

    const getChannelIds = async (channelNames) => {
        const channelIds = [];

        for (const name of channelNames) {
            const response = await fetch(`https://www.googleapis.com/youtube/v3/channels?part=id&forUsername=${name}&key=${apiKey}`);
            const data = await response.json();
            if (data.items && data.items.length > 0) {
                channelIds.push(data.items[0].id);
            } else {
                console.error(`Канал ${name} не найден или произошла ошибка:`, data);
            }
        }

        return channelIds;
    };

    // Функция для получения ивентов
    const getEvents = async (channelIds) => {
        const events = [];

        for (const id of channelIds) {
            const response = await fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${id}&eventType=all&type=video&key=${apiKey}`);
            const data = await response.json();

            if (data.items) {
                data.items.forEach(item => {
                    const event = {
                        title: item.snippet.title,
                        link: `https://www.youtube.com/watch?v=${item.id.videoId}`,
                        isLive: item.snippet.liveBroadcastContent === 'live',
                        scheduledStart: item.snippet.publishedAt // Здесь можно добавить логику для определения запланированного времени
                    };
                    events.push(event);
                });
            } else {
                console.error(`Ошибка при получении ивентов для канала ID ${id}:`, data);
            }
        }

        return events;
    };

    // Используем useEffect для получения данных при монтировании компонента
    useEffect(() => {
        const fetchData = async () => {
            const channelIds = await getChannelIds(channelNames);
            const eventsData = await getEvents(channelIds);
            setEvents(eventsData);
        };

        fetchData();
    }, [channelNames]);

    return (
        <div>
            <h1>Ивенты YouTube</h1>
            <ul>
                {events.map((event, index) => (
                    <li key={index}>
                        <a href={event.link} target="_blank" rel="noopener noreferrer">{event.title}</a>
                        {event.isLive ? <span> (Текущий стрим)</span> : <span> (Запланированный)</span>}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default YouTubeEvents;
